const API_BASE = "https://hiflowapi.stechomeyazilim.info";

/**
 * Advert_Pricing tablosundan iptal politikalarını çeker.
 * Is_Cancel_Policy=true olan satırları Cancel_Days_Limit'e göre ASC sıralar.
 */
export const fetchCancelPolicies = async () => {
  const res = await fetch(
    `${API_BASE}/Advert_Pricing?$filter=Is_Cancel_Policy eq true&$orderby=Cancel_Days_Limit asc`
  );
  const data = await res.json();
  return data.value || [];
};

/**
 * Kalan gün sayısına göre iptal ücretini ve politika ID'sini döner.
 * Sıralama ASC olduğu için ilk eşleşen (en düşük limit) kullanılır.
 *
 * Örnek politikalar:
 *   Cancel_Days_Limit=0, Price=600  → aynı gün iptal
 *   Cancel_Days_Limit=3, Price=300  → 1-3 gün öncesi iptal
 *   eşleşme yoksa → ücretsiz
 *
 * @param {number} diffDays - Göreve kalan gün sayısı
 * @param {Array}  policies - fetchCancelPolicies() çıktısı
 * @returns {{ fee: number, pricingId: number|null }}
 */
export const calcCancelFee = (diffDays, policies) => {
  const sorted = [...policies].sort((a, b) => a.Cancel_Days_Limit - b.Cancel_Days_Limit);
  const matched = sorted.find(p => diffDays <= p.Cancel_Days_Limit);
  return matched
    ? { fee: matched.Price, pricingId: matched.ID }
    : { fee: 0, pricingId: null };
};

/**
 * Kullanıcının ödenmemiş iptal cezası olup olmadığını kontrol eder.
 * Is_Paid = false olan kayıtlar ödenmemiş borç sayılır.
 * @param {number} userId
 * @returns {{ hasDebt: boolean, totalDebt: number }}
 */
export const hasUnpaidCancelFee = async (userId) => {
  try {
    const policiesRes = await fetch(
      `${API_BASE}/Advert_Pricing?$filter=Is_Cancel_Policy eq true`
    );
    const policiesData = await policiesRes.json();
    const cancelIds = (policiesData.value || []).map(p => p.ID);

    if (cancelIds.length === 0) return { hasDebt: false, totalDebt: 0 };

    const idFilter = cancelIds.map(id => `Advert_Pricing_ID eq ${id}`).join(" or ");
    const debtRes = await fetch(
      `${API_BASE}/Users_Advert_Pricing?$filter=Users_ID eq ${userId} and (${idFilter}) and Is_Paid eq false&$expand=Advert_Pricing`
    );
    const debtData = await debtRes.json();
    const rows = debtData.value || [];
    const totalDebt = rows.reduce((sum, r) => sum + (r.Price || r.Advert_Pricing?.Price || 0), 0);
    return { hasDebt: rows.length > 0, totalDebt };
  } catch {
    return { hasDebt: false, totalDebt: 0 };
  }
};
